export const ItemTypes = { ROOM: "room" };



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/components/ItemTypes.js